module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "news-list"
  }, [_c('display-img', {
    attrs: {
      "images": _vm.imageItems,
      "size": _vm.size
    }
  }), _vm._v(" "), _c('h4', [_vm._v("新闻列表")]), _vm._v(" "), _c('ul', {
    staticClass: "news-list"
  }, _vm._l((_vm.news), function(item) {
    return _c('li', [_c('router-link', {
      staticClass: "news-href",
      attrs: {
        "to": _vm.newsLink + item.id,
        "title": item.title
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "news-time"
    }, [_vm._v("发布日期：" + _vm._s(item.createdate ? item.createdate : item.date))])])], 1)
  })), _vm._v(" "), (_vm.pageCount > 1) ? _c('div', {
    staticClass: "list-navgation"
  }, [(_vm.showPreventPage) ? _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-type": "pre"
    },
    on: {
      "click": _vm.preventPageClick
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageNumber), function(index) {
    return _c('a', {
      class: {
        active: _vm.currentPage == index
      },
      attrs: {
        "data-page": index
      },
      on: {
        "click": _vm.pageClick
      }
    }, [_vm._v(_vm._s(index))])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d6b3c27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/NewsList.vue
// module id = 169
// module chunks = 1